import { render, staticRenderFns } from "./otaconfigure.vue?vue&type=template&id=10807f44&scoped=true"
import script from "./otaconfigure.vue?vue&type=script&lang=js"
export * from "./otaconfigure.vue?vue&type=script&lang=js"
import style0 from "./otaconfigure.vue?vue&type=style&index=0&id=10807f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10807f44",
  null
  
)

export default component.exports